import { EhrBillingSection } from "@/components/landing/ehr/EhrBillingSection";
import { EhrClosingSection } from "@/components/landing/ehr/EhrClosingSection";
import { EhrFounderNote } from "@/components/landing/ehr/EhrFounderNote";
import { EhrQuestionsSection } from "@/components/landing/ehr/EhrQuestionsSection";
import { WaitlistForm } from "@/components/landing/waitlist/WaitlistForm";
import { WaitlistLayout } from "@/components/landing/waitlist/WaitlistLayout";

/**
 * /ehr - the free EHR waitlist, where both free EHR Meta ads land and where
 * the homepage's banner, navigation and footer send visitors. Name and email
 * open the practice questions (with the current EHR), and "Join the waitlist"
 * under them signs up and shows the booking calendar.
 *
 * "Free" alone reads as a scam to practices, so the page answers it in the
 * order the doubts come: why it's free (the founder's note), what AI billing
 * adds, then the questions (not a trial, no ads, no data sale), and the form
 * again at the end.
 *
 * Meta reviews the landing page as well as the ad, so the page says
 * behavioral health rather than naming the conditions programs treat. The
 * EHR's features are not named, and nothing on the page dates it.
 */
export default function EhrPage() {
  return (
    <WaitlistLayout
      documentTitle="Free EHR for behavioral health, with AI billing · Altair"
      title={
        <>
          <span style={{ whiteSpace: "nowrap" }}>Next-generation</span> EHR{" "}
          <span className="wl-br">
            for <span style={{ whiteSpace: "nowrap" }}>behavioral health.</span>
          </span>
        </>
      }
      subhead="Completely free, with AI billing built in."
      sections={
        <>
          <EhrFounderNote />
          <EhrBillingSection />
          <EhrQuestionsSection />
          <EhrClosingSection>
            <EhrWaitlistForm />
          </EhrClosingSection>
        </>
      }
    >
      <EhrWaitlistForm />
    </WaitlistLayout>
  );
}

function EhrWaitlistForm() {
  return (
    <WaitlistForm
      page="free-ehr"
      submitLabel="Join the waitlist"
      note={
        <>
          HIPAA compliant <span aria-hidden="true" style={{ opacity: 0.4 }}>·</span>{" "}
          <a
            href="https://trust.altair-health.com"
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline"
            style={{ color: "hsl(220 60% 42%)" }}
          >
            Trust Center<span aria-hidden="true"> ↗</span>
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
        </>
      }
      doneTitle="You're on the list."
      placeTitle={(place) => `You're #${place} on the list.`}
      doneNote="Book a call with the team."
      maxWidth={620}
      askCurrentEhr
    />
  );
}
